jQuery(document).ready(function() {
  jQuery("a.my-cart-link, .jsc-close-btn, #jsc-backdrop").click(function(e) {
    jQuery("#jsc").toggleClass("jsc-active");
    if($("#jsc").hasClass("jsc-active")){
      $("body").css("overflow-y", "hidden");
      $("#jsc").focus(); /* A11y */
    }else{
      $("body").css("overflow-y", "scroll");
    }
    //jscInitCart();
    return false;
  });


  $("span.jsc-ll-available").click(function(){
    $(this).toggleClass('active');
    $("#jsc-ll-inline-rewards").toggle();
  });

});

document.addEventListener('status:shopify:login', (event) => {
  location.reload();
});

var jdUnlockCookie = {
  getCookie: function(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
  },
  setCookie: function(name, value, mins) {
    var d = new Date;
    d.setTime(d.getTime() + 60*1000*mins);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
  },
  deleteCookie:function(name) { setCookie(name, '', -1); }
}

var jscCurrency = Shopify.currency.active;
//console.log(jscCurrency);

var jscCurrency;
var jscCurrencySymbol = "$";
var jdFormatMoney = function(amount){
  return Shopify.formatMoney(amount, Currency.moneyFormats[Shopify.currency['active']].money_with_currency_format);
}

// switch (jscCurrency) {
//   case 'USD':
//     jscCurrencySymbol = "$";
//     break;

//   case 'CAD':
//     jscCurrencySymbol = "$";
//     break;

//   case 'AUD':
//     jscCurrencySymbol = "$";
//     break;

//   case 'EUR':
//     jscCurrencySymbol = "€";
//     break;

//   case 'GBP':
//     jscCurrencySymbol = "£";
//     break;
//   case 'ILS':
//     jscCurrencySymbol = "NIS ";
// }

//console.log(jscCurrencySymbol);

var jscCartData, jscCartCompare = "";
var cartCountMinus = 0;

const jscInitCart = function(openAfter, cart) {
  cart = cart || false;

  if(cart != false && openAfter == true){
    if(jscPopulateCart(cart)){
      jQuery("#jsc").toggleClass("jsc-active");
      if($("#jsc").hasClass("jsc-active")){
        $("body").css("overflow-y", "hidden");
          $("#jsc").focus(); /* A11y */
      }else{
        //$("body").css("overflow-y", "scroll");
      }
    }
    return true;
  } else {
    jQuery.ajax({
      type: "GET",
      //url: window.Shopify.routes.root.replace(/\/$/, "")+"/cart.js",
      url: window.Shopify.routes.root+"cart.js",
      dataType: "json",
      success: function(data, status, xhr) {
        jscCartCompare = JSON.stringify(data.items);
        if (jscCartData == jscCartCompare) {
          return data;
        } else {
          //console.log("cart data not the same:" +data.items);
          if (data.item_count == 0) {
            jscEmptyCart();
          } else {
            if(jscPopulateCart(data) && openAfter == true){
              jQuery("#jsc").toggleClass("jsc-active");
              if($("#jsc").hasClass("jsc-active")){
                $("body").css("overflow-y", "hidden");
                  $("#jsc").focus(); /* A11y */
              }else{
                $("body").css("overflow-y", "scroll");
              }
            }
          }
        }
  
        return data;
      },
      error: function(xhr, status, error) {
        console.log("JSC Cart Error: " + xhr.error);
        return "JSC Cart Error: " + xhr.error;
      }
    });
  }
}

const jscToggleCart = function(){
   jscInitCart(true);
}

function jscPopulateCart(cart) {
  
  //console.log(cart);

  if (cart.item_count > 0) {
    var jscTemplate = jQuery("#jscCartTemplate").text();
    jQuery("#jsc-items").empty();
    jQuery("#jsc-items").removeClass("jsc-empty-cart");
    jQuery.each(cart.items, function(i, e) {
      
      if(e.product_title.indexOf("Free Engraving") !== -1){
        return true;
      }

      if(e.handle == "shipinsure"){
        cartCountMinus = cartCountMinus+1;
        return true;
      }

      var jscItem = jscTemplate;

      var jscItemPrice = jdFormatMoney(e.line_price);

      //console.log("JD PRICE: ", e.line_price);
      
      

      jscItem = jscItem.replace("{JSCIMG}", e.featured_image.url);
      jscItem = jscItem.replace("{JSCALT}", e.featured_image.alt.replace("Adina", "Adina Eden"));
      jscItem = jscItem.replace("{JSCTITLE}", e.product_title);

      if (!jQuery.isEmptyObject(e.properties)) {

        if(e.product_title == "Free Engraving"){
          jscItem = jscItem.replace("{JSCPROPERTY}", "");  
        }else{
          var jscItemProperties = '';
          jQuery.each(e.properties, function(i, e) {
            // SKIP ADDING PROPERTIES IF CONDITION MET AND SKIP PROPERTIES THAT START WITH AN UNDERSCORE "_"
            var firstChar = i[0];
            if(firstChar == "_"){
              return true;
            }
            
            if(i.indexOf("Add Free Engraving") !== -1){
              jscItemProperties += "Free Engraving: Yes<br />";
              return true;
            }
            
            // Commented because it is replaced by Purple Dot's estimated delivery info
            // if(i.indexOf("Pre-order") !== -1){
            //   jscItemProperties += "Pre-order<br />";
            //   return true;
            // }
            
            if(i.indexOf("Estimated shipping") !== -1){
              var jscEstShip = e;
              jscEstShip = jscEstShip.replace(" days", "");
              const d = new Date();
              d.setDate(d.getDate() + parseInt(jscEstShip));
              var jd_pp_ship_date = d.toDateString();
              jscItemProperties += "Est. shipping: "+jd_pp_ship_date+"<br />";
              return true;
            }

            if (i.indexOf("__") === 0) {
              // Hides private properties
              return true;
            }

            jscItemProperties += i+": "+e+"<br />";
          });
          jscItem = jscItem.replace("{JSCPROPERTY}", jscItemProperties);
        }
      } else {
        jscItem = jscItem.replace("{JSCPROPERTY}", "");
      }

      if(e.product_title == "Free Engraving"){
        jscItem = jscItem.replace("{JSCVARIANT}", '');
        jscItem = jscItem.replace("{QUANTITYHIDE}", 'jsc-quantity-hidden');
      }else{
        jscItem = jscItem.replace("{JSCVARIANT}", e.variant_title);
        jscItem = jscItem.replace("{QUANTITYHIDE}", '');
      }

      jscItem = jscItem.replaceAll("{JSCVARIANTID}", e.variant_id);
      jscItem = jscItem.replaceAll("{JSCLINEKEY}", e.key);
      jscItem = jscItem.replace("{JSCPRODUCTHANDLE}", e.handle);
      jscItem = jscItem.replaceAll("{JSCQUANTITY}", e.quantity);

      var store_settings = jQuery.parseJSON(jQuery("#jda_settings").text());
      if(store_settings.jd_enable_sale == "true" && store_settings.jd_sale_type != "none" && store_settings.jd_sale_percentage != "" && store_settings.jd_enable_prep != "true"){
        var jd_enable_sale = true;
        var jd_sale_type = store_settings.jd_sale_type;
        var jd_sale_percentage = (100 - parseInt(store_settings.jd_sale_percentage)) / 100;
        if (store_settings.jd_discount_notice != "") {
          var jd_discount_notice = store_settings.jd_discount_notice;
        } else {
          var jd_discount_notice = false;
        }
      } else {
        var jd_enable_sale = false;
        var jd_sale_type = false;
        var jd_discount_notice = false;
      }


      

      var salePriceString = '';
      var exclusivePriceString = '';
      

      
      if(e.product_type == "Accessories"){
        if(e.original_price > e.discounted_price){
          jscItem = jscItem.replace("{JSCPRICE}", "<span class='money was'><s>"+ jdFormatMoney(e.original_line_price) +"</s></span>&nbsp;&nbsp;<span class='money'>"+ jscItemPrice +"</span>");
        } else {
          jscItem = jscItem.replace("{JSCPRICE}", jscItemPrice);
        }
      } else {
        if(jd_enable_sale == true && jd_sale_type == "sitewide"){
            if(e.original_price > e.discounted_price){
              jscItem = jscItem.replace("{JSCPRICE}", "<span class='money was'><s>"+ jdFormatMoney(e.original_line_price) +"</s></span>&nbsp;&nbsp;<span class='money' style='color: #CF0C71!important; font-weight: 500;'>"+ jscItemPrice +"</span>");
            } else {
              jscItem = jscItem.replace("{JSCPRICE}", jscItemPrice + salePriceString);
            }
        } else if(jd_enable_sale == true && jd_sale_type == "saleitems" && jQuery("[data-saleitem-product]").length > 0){
            if(e.original_price > e.discounted_price){
              jscItem = jscItem.replace("{JSCPRICE}", "<span class='money was'><s>"+ jdFormatMoney(e.original_line_price) +"</s></span>&nbsp;&nbsp;<span class='money'>"+ jscItemPrice +"</span>" + salePriceString);
            } else {
              jscItem = jscItem.replace("{JSCPRICE}", jscItemPrice + salePriceString);
            }
        } else if(jd_enable_sale == true && jd_sale_type == "activation" && jdUnlockCookie.getCookie("jd-sale-unlock") != null){
            if(e.original_price > e.discounted_price){
              jscItem = jscItem.replace("{JSCPRICE}", "<span class='money was'><s>"+ jdFormatMoney(e.original_line_price) +"</s></span>&nbsp;&nbsp;<span class='money'>"+ jscItemPrice +"</span>" + exclusivePriceString);
            } else {
              jscItem = jscItem.replace("{JSCPRICE}", jscItemPrice + exclusivePriceString);
            }
        } else {
          if(e.original_price > e.discounted_price){
            jscItem = jscItem.replace("{JSCPRICE}", "<span class='money was'><s>"+ jdFormatMoney(e.original_line_price) +"</s></span>&nbsp;&nbsp;<span class='money'>"+ jscItemPrice +"</span>");
          } else {
            jscItem = jscItem.replace("{JSCPRICE}", jscItemPrice);
          }
        }
      }
      
      

      // adjust url for locale aware urls
      var cleanURL = e.url;
      if(cleanURL.charAt(0) == "/"){
        cleanURL = cleanURL.substring(1);
      }
      jscItem = jscItem.replace("{JSCLINK}", e.url);
      

      var jscItemHandler = jQuery(jscItem).appendTo(jQuery("#jsc-items"));
    });

    jscCartData = JSON.stringify(cart.items);

    return jscPopulateCartTotals(cart);
  } else {
    jQuery("#jsc-items").empty();
    jscEmptyCart();
    jscPopulateCartTotals(cart);
    return false;
  }
}

function jscEmptyCart() {
  jQuery("#jsc-items").addClass("jsc-empty-cart");
  jQuery("#jsc-items").html("<div class='jsc-empty-cart'>You do not have any items in the cart.</div>");
}

function jscPopulateCartTotals(cart) {
  
  var store_settings = jQuery.parseJSON(jQuery("#jda_settings").text());
  if(store_settings.jd_enable_sale == "true" && store_settings.jd_sale_type != "none" && store_settings.jd_sale_percentage != ""){
    var jd_enable_sale = true;
    var jd_sale_type = store_settings.jd_sale_type;
    var jd_sale_percentage = (100 - parseInt(store_settings.jd_sale_percentage)) / 100;
    if (store_settings.jd_discount_notice != "") {
      var jd_discount_notice = store_settings.jd_discount_notice;
    } else {
      var jd_discount_notice = false;
    }
  } else {
    var jd_enable_sale = false;
    var jd_sale_type = false;
    var jd_discount_notice = false;
  }

  
  var jscFooter = $("#jsc-footer");
  var jscSubtotalPrice = jdFormatMoney(cart.items_subtotal_price);
  
  var jscOriginalTotal = jdFormatMoney(cart.original_total_price);
  var jscDiscountTotal = jdFormatMoney(cart.total_discount);
  var jscTotalPrice = jdFormatMoney(cart.total_price);
  
  

  if(cart.original_total_price){
    $("#jsc-subtotal").html(jscOriginalTotal);
    $(".jsc-total-line.jsc-subtotal").show();
  } else {
    $(".jsc-total-line.jsc-subtotal").hide();
  }
  
  if(cart.total_discount){
    $("#jsc-savings-price").html("-"+jscDiscountTotal); 
    $(".jsc-total-line.jsc-savings").show();
  } else {
    $(".jsc-total-line.jsc-savings").hide();
  }
  
  $("#jsc-total-price").html(jscTotalPrice).addClass("money");
  
  // add final sale to mini cart

  
  
  
    var jdFinalSaleString = '<div class="jd-slide-final-sale"><span class="onsale jd-onsale" style="display: block; font-weight: 400!important; color: #000!important;">Final Sale</span></div>';
    $("#jsc-items > .jsc-item").each(function(){
      if($(this).find(".jsc-item-mid").find('.jd-slide-final-sale').length < 1){
        $(this).find(".jsc-item-mid").append(jdFinalSaleString);
      }
    });
  
  
  
  
  
  
  
  var jscMeterTotal = jscTotalPrice.replace(/[$€£]/g, "");
  var jscMeterTotalSplit = jscMeterTotal.split(".");
  $("#jsc-m-total").text(jscMeterTotal);
  if(jscMeterTotal > -1 && jscMeterTotal < 126){
    $(".jsc-m-bar-inner").css("width", jscMeterTotal/125*100+"%" );
  } else {
    $(".jsc-m-bar-inner").css("width", "100%" );
  }

  if(jscMeterTotal < 1){
    $("#jsc-rewards-lang").html("Spend <b style='color: #CF0C71; font-weight: 600;'>$125+</b> To Unlock Free Shipping!");
  } else if(jscMeterTotal < 125){
    $("#jsc-rewards-lang").html("You're <b style='color: #CF0C71; font-weight: 600;'>$"+ (125-jscMeterTotal).toFixed(2) +"</b> Away From Free Shipping!");
  } else {
    $("#jsc-rewards-lang").html("Congrats! You've Unlocked Free Shipping!");
  }

  
  
  
  $("#item_count.item_count").html(cart.item_count-cartCountMinus);

  //update_variant_compare_at_prices();

  //window.jd_currency_update();

  return true;
}

function update_variant_compare_at_prices(){
  $("#jsc-items > div.jsc-item").each(function(i, originalProduct) {
    var originalVariant = $(this).data("variant");
    var compareAtPrice = "";
    var quantity = parseInt($(this).find(".jsc-current-quantity").text());
      $.ajax({ 
        url: '/products/' + $(this).data("handle") + '.js', 
        dataType: 'json',
        async: false, 
        success: function(product){ 
          $(product.variants).each(function(i, variant) {
            if (variant.compare_at_price != null && variant.id == originalVariant)
              $(originalProduct).find(".jsc-item-price s").text(jdFormatMoney(variant.compare_at_price*quantity));
          });
        } 
      });
    });
}

jQuery('body').on('click', 'button.jsc-quantity-adjuster', function(event) {
  event.stopPropagation();
  if (jQuery(this).hasClass("jsc-minus")) {
    jscDecreaseQty(jQuery(this), jQuery(this).data("key"), jQuery(this).data("quantity"));
  } else if (jQuery(this).hasClass("jsc-plus")) {
    jscIncreaseQty(jQuery(this), jQuery(this).data("key"), jQuery(this).data("quantity"));
  }
});

jQuery('body').on('click', 'button.jsc-item-remove', function() {
  jscRemoveItem(jQuery(this), jQuery(this).data("key"));
});

window.jscCounter = 0;

function jscIncreaseQty(e, id, n) {
  $(e).closest(".jsc-quantity").addClass("disabled");
  jQuery.post(window.Shopify.routes.root.replace(/\/$/, "")+'/cart/change.js', {
    id: id,
    quantity: (parseInt(n) + 1)
  }, null, "json").done(function(data, status) {
    //console.log(data);
    //console.log("JSC Counter:", ++window.jscCounter);
    jscPopulateCart(data);
  }).fail(function(data, status) {
    console.log("JSC: Cannot update quantity due to an error: " + status);
    $(e).closest(".jsc-quantity").removeClass("disabled");
    //jscPopulateCart(data);
  });
}

function jscDecreaseQty(e, id, n) {
  $(e).closest(".jsc-quantity").addClass("disabled");
  var isRemovedItem = true;
  jQuery.post(window.Shopify.routes.root.replace(/\/$/, "")+'/cart/change.js', {
    id: id,
    quantity: (parseInt(n) - 1)
  }, null, "json").done(function(data, status) {
    //console.log(data);
    //console.log("JSC Counter:", ++window.jscCounter);
    jscPopulateCart(data);
  }).fail(function(data, status) {
    console.log("JSC: Cannot update quantity due to an error: " + status);
    $(e).closest(".jsc-quantity").removeClass("disabled");
    jscPopulateCart(data);
  });
}

function jscRemoveItem(e, id) {
  $(e).closest(".jsc-item").find(".jsc-quantity").addClass("disabled");
  var jscItemId = $(e).attr("data-variant");
  var jscItemFound = false;
  jQuery.post(window.Shopify.routes.root.replace(/\/$/, "")+'/cart/change.js', {
    id: id,
    quantity: 0
  }, null, "json").done(function(data, status) {
    $(e).closest(".jsc-item").find(".jsc-quantity").removeClass("disabled");
    jscPopulateCart(data);

    if(jscItemId == "31563314233418"){
      $("#is-gift").prop("checked", false);
      $("#to-from").hide();
      jQuery.post(window.Shopify.routes.root.replace(/\/$/, "")+'/cart/update.js', "attributes[customer-is-gift]=");
      setTimeout(function(){
        jQuery.post(window.Shopify.routes.root.replace(/\/$/, "")+'/cart/update.js', {
          attributes:{
            'customer-gift-to':'',
            'customer-gift-from':'',
            //'customer-gift-delivery-date':''
          },
          updates: {
            31563314233418: 0
          }
        });
      }, 1000);
    } else if(jscItemId == "40175906095178"){
      $("input[data-attr=extra-packaging]").prop("checked", false);
      jQuery.post(window.Shopify.routes.root.replace(/\/$/, "")+'/cart/update.js', {
        attributes:{
          'extra-packaging':'',
        },
        updates: {
          40175906095178: 0
        }
      });
    } else if(jscItemId == "40189306110026"){
      $("input[data-attr=cleaning-kit]").prop("checked", false);
      jQuery.post(window.Shopify.routes.root.replace(/\/$/, "")+'/cart/update.js', {
        attributes:{
          'cleaning-kit':'',
        },
        updates: {
          40189306110026: 0
        }
      });
    }
  }).fail(function(data, status) {
    console.log("JSC: Cannot update quantity due to an error: " + status);
    $(e).closest(".jsc-item").find(".jsc-quantity").removeClass("disabled");
    jscPopulateCart(data);
  });
}

jscInitCart();

document.addEventListener('jdPSOCart', (e) => {
  setTimeout(function(){
    jscInitCart(true, false);
  }, 1000);
}, false);

document.addEventListener('minicartNoteAdded', (e) => {
  setTimeout(function(){
    jscInitCart();
  }, 2000);
}, false);

document.addEventListener('minicartNoteRemoved', (e) => {
  setTimeout(function(){
    jscInitCart();
  }, 2000);
}, false);

document.addEventListener('nostoUpdateCart', (e) => {
  setTimeout(function(){
    jscInitCart();
  }, 2000);
}, false);

document.addEventListener('jdApAdded', (e) => {
  setTimeout(function(){
    jscInitCart();
  }, 1000);
}, false);

document.addEventListener('nostoFilterCallback', (e) => {
  console.log("nosto callback event firing!");
}, false);